/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { TransitionGroup } from 'react-transition-group'
import FloatNotification from './FloatNotification'
import styled from '@emotion/styled'

const StyledDiv = styled('div')`
  background: transparent;
  margin: 32px;
  position: absolute;
  top: 0;
  right: 0;
  pointer-events: none;
  z-index: 1;
`

const NotificationContext = ({ notifications }) => (
  <TransitionGroup component={StyledDiv}>
    {notifications.map((notification, i) => (
      <FloatNotification
        key={notification.id}
        notification={{ index: i, ...notification }}
      />
    ))}
  </TransitionGroup>
)

NotificationContext.propTypes = {
  notifications: PropTypes.arrayOf(PropTypes.object),
}

NotificationContext.defaultProps = {
  notifications: [],
}

export default NotificationContext
